import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { alpha, Box, Button, Grid2, Typography } from '@mui/material';
import { Chip } from '@utriper/core-ui';
import Placeholder from 'assets/images/placeholder.webp';
import ImageGallery from './components/ImageGallery';
import { formatCurrencyWithDecimals } from '@utriper/core';

const BundleCard = ({ name, bundleExperiences = [], pricing, handleOpen = () => {} }) => {
    const { i18n } = useTranslation();
    const { fromPrice, fromPriceOriginal, currency, discountRate } = pricing;
    const images = useMemo(
        () =>
            bundleExperiences
                .map((exp) => {
                    const imageSrc = exp?.pictureURL ? `${process.env.REACT_APP_CDN_URL}${exp.pictureURL}` : null;

                    return imageSrc;
                })
                .filter(Boolean),
        [bundleExperiences]
    );
    const MAX_VISIBLE = 5;

    return (
        <Grid2
            container
            size={{ xs: 12, sm: 6 }}
            sx={{
                height: 'fit-content',
                padding: '1em',
                borderRadius: '.5em',
                border: 'solid #13131340 1px',
                boxShadow: 'var(--shadow-card)',
                backgroundColor: '#fff',
                gap: '1em',
                transition: 'all .2s ease-in-out',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0px 4px 20px 0px rgba(0,0,0,0.05)',
                },
            }}
        >
            {/* Image */}
            <Box sx={{ width: '100%', height: 'fit-content' }}>
                {images?.length > 0 ? (
                    <ImageGallery images={images} name={name} />
                ) : (
                    <Box
                        component="img"
                        src={Placeholder}
                        alt={`${name}-image`}
                        sx={{
                            aspectRatio: '16 / 9',
                            objectFit: 'cover',
                            objectPosition: 'center',
                            width: '100%',
                            height: 'auto',
                            borderRadius: '8px',
                        }}
                    />
                )}
            </Box>

            {/* Data */}
            <Grid2
                container
                size={12}
                spacing={1.5}
                direction="column"
                sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                <Typography fontSize={16} fontWeigth={700} sx={{ color: '#131313', maxWidth: '100%' }} noWrap>
                    {name}
                </Typography>

                {/* {bundleExperiences?.length > 0 && (
                    <Typography fontSize={14} fontWeigth={700} sx={{ color: '#131313', maxWidth: '100%' }} noWrap>
                        {`${bundleExperiences.length} experiencia(s)`}
                    </Typography>
                )} */}
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                    }}
                >
                    {bundleExperiences.slice(0, MAX_VISIBLE).map((exp) => (
                        <Chip
                            key={exp?.id}
                            label={exp?.name}
                            title={exp?.name}
                            size="small"
                            sx={{
                                maxWidth: 140,
                                '& .MuiChip-label': {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                },
                            }}
                        />
                    ))}
                </Box>

                {Number.isFinite(fromPrice) && fromPrice > 0 ? (
                    <Grid2 container size={12} spacing={1} direction="column">
                        {Number.isFinite(fromPriceOriginal) && fromPriceOriginal > fromPrice && discountRate > 0 && (
                            <Grid2 container alignItems="center" gap={1.5}>
                                <Typography
                                    fontSize={13}
                                    sx={{
                                        color: '#131313',
                                        textDecoration: 'line-through',
                                    }}
                                >
                                    {formatCurrencyWithDecimals(fromPriceOriginal, currency, i18n.language, 0)}
                                </Typography>

                                <Chip
                                    label={`-${discountRate}%`}
                                    sx={{
                                        background: alpha('#50C878', 0.25),
                                        color: '#50C878',
                                        borderRadius: '4px',
                                    }}
                                />
                            </Grid2>
                        )}

                        <Grid2 container size={12} gap={0.5}>
                            <Typography fontSize={14} fontWeight={600} sx={{ color: '#131313' }}>
                                {`Desde `}
                            </Typography>
                            <Typography fontSize={14} fontWeight={600} sx={{ color: '#137DC5' }}>
                                {formatCurrencyWithDecimals(fromPrice, currency, i18n.language, 0)}
                            </Typography>
                        </Grid2>
                    </Grid2>
                ) : (
                    <Typography fontSize={14} fontWeight={600} sx={{ color: '#131313' }}>
                        ¡Gratis!
                    </Typography>
                )}
            </Grid2>

            <Button
                sx={{
                    fontWeight: 600,
                    width: '100%',
                    color: 'white',
                    backgroundColor: '#137DC5',
                }}
                variant="contained"
                onClick={handleOpen}
            >
                Agregar
            </Button>
        </Grid2>
    );
};

export default BundleCard;
